/**
 * BLOCK: spinner
 */

jQuery(document).ready(function ($) {
  window.$ = $;

  class LutherSpinner {
    constructor() {
      this.wrapper = document.querySelector("body > .spinner-wrapper");
      this.spinner = document.querySelector(
        "body > .spinner-wrapper > .spinner"
      );

      this.preventNext = false;

      // show on beforeunload
      $(document).on("click", "a", this._handleLinkClicks.bind(this));
    }

    _isDownload(href) {
      var re = /(?:\.([^.]+))?$/;
      var ending = re.exec(href)[1];
      var fileEndings = [
        "zip",
        "mp3",
        "mp4",
        "png",
        "jpg",
        "jpeg",
        "svg",
        "pdf",
      ];

      return fileEndings.indexOf(ending) != -1;
    }

    _isSamePage(href) {
      var l = document.createElement("a");
      l.href = href;
      return l.pathname == window.location.pathname;
    }

    preventNextSpinner() {
      this.preventNext = true;
    }

    _handleLinkClicks(e) {
      if (this.preventNext) {
        this.preventNext = false;
        return true;
      }

      var elem =
        e.target.nodeName == "A" ? $(e.target) : $(e.target.parentNode);
      var href = elem.attr("href");

      if (!href) {
        return true;
      }

      if (elem.attr("target") == "_blank") {
        return true;
      }

      if (elem.hasClass("no-spinner")) {
        return true;
      }

      if (this._isDownload(href)) {
        return true;
      }

      // if is no hash show spinner
      if (href.indexOf("#") === -1) {
        this.show();
      }

      // if is same page show spinner
      if (!this._isSamePage(href)) {
        this.show();
      }
    }

    show() {
      this.wrapper.classList.add("visible");
    }

    hide() {
      this.wrapper.classList.remove("visible");
    }
  }

  window.luther = window.luther || {};
  window.luther.spinner = new LutherSpinner();
});
